import { log } from '@/logger/logger';
import type { ResolvedAssets } from '@/types/api/assets';

const logger = log.getLogger('blobstoreTelemetry');
const warnedAssetIds = new Set<string>();

export function logUnresolvedRef(assetId: string | undefined, resolved: ResolvedAssets, source: string): void {
  if (!assetId || resolved[assetId]?.signedUrl || warnedAssetIds.has(assetId)) {
    return;
  }

  warnedAssetIds.add(assetId);
  logger.warn(`Blobstore asset id ${assetId} unresolved in ${source}; falling back to Cloudinary`);
}
